import { ReturnAnalyticsType } from 'app/analytics/useAnalytics';
import { NotificationContextManager } from 'app/store/сontext/NotificationContextProvider';
import { ValidationException } from 'app/api/exception/ValidationException';

const UNEXPECTED_ERROR_MESSAGE =
    'Не удалось выполнить операцию. Попробуйте ещё раз позже';

/**
 * Получить обработчик ошибки по наименованию класса исключения.
 * Handler выполнится только если наименование класса пойманного исключение не соответствует переданному.
 * Иначе исключение пробрасывается.
 *
 * @param errorName наименование класса исключения.
 * @param handler обработчик исключения.
 */
export const anyExceptionExcept = <T extends Error>(
    errorName: string,
    handler: (error: T) => void,
) => {
    return (error: T) => {
        if (error.name !== errorName) {
            handler(error);
        } else {
            throw error;
        }
    };
};

/**
 * Получить обработчик ошибки по наименованию класса исключения.
 * Handler выполнится только если наименование класса пойманного исключения не соответствует ни одному из переданных.
 * Иначе исключение пробрасывается.
 *
 * @param errorName наименование класса исключения.
 * @param handler обработчик исключения.
 */
export const anyExceptionExceptListed = <T extends Error>(
    errorNames: string[],
    handler: (error: T) => void,
) => {
    return (error: T) => {
        if (!errorNames.includes(error.name)) {
            handler(error);
        } else {
            throw error;
        }
    };
};

/**
 * Обработчик исключения по умолчанию.
 * @param notification менеджер нотификаций
 * @param analytics менеджер аналитики
 * @param setPageErrors менеджер ошибок страницы
 */
export const defaultExceptionHandler = (
    notification: NotificationContextManager,
    analytics: ReturnAnalyticsType,
    setPageErrors?: (error: string[]) => void,
) => {
    /**
     * {@link anyExceptionExcept} - необходим т.к. наиболее общее исключение выполняется до обработки ValidationException в механизме управления формой.
     *
     * Возможные варианты решения:
     * - передавать обработчик исключения по умолчанию в конструктор формы.
     * - устанавливать обработчик после выполняемого действий (для метода onSubmitForm)
     */
    return anyExceptionExcept(ValidationException.NAME, () => {
        analytics.reject();
        notification.addNotification({});
        setPageErrors && setPageErrors([UNEXPECTED_ERROR_MESSAGE]);
    });
};
